<template>
    <main class="main">

        <AppHeader :sidebar-open="sidebarOpen" @openSidebar="openSidebar" @closeSidebar="closeSidebar" />
        <AppSidebar :sidebar-open="sidebarOpen" @openSidebar="openSidebar" @closeSidebar="closeSidebar" />

        <section class="content">
            <transition name="fade">
                <router-view></router-view>
            </transition>

            <AppFooter></AppFooter>
        </section>
    </main>
</template>

<script>
import AppFooter from '@components/AppFooter';
import AppHeader from '@components/AppHeader';
import AppSidebar from '@components/AppSidebar';

export default {
  name: 'full',
  components: {
    AppHeader,
    AppSidebar,
    AppFooter,
  },
  data() {
    return {
      sidebarOpen: false,
    };
  },
  mounted() {
    setTimeout(() => document.querySelector('#pageLoader').classList.add('fadeOutDown', 'animated'), 1500);
  },
  computed: {},
  methods: {
    openSidebar() {
      this.sidebarOpen = true;
    },
    closeSidebar() {
      this.sidebarOpen = false;
    },
  },
};
</script>
